/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var ArrowFigureACircleDownIcon32Regular = forwardRef('ArrowFigureACircleDownIcon32Regular', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 32 }, props),
        React.createElement("path", { d: "M16 9a1 1 0 0 1 1 1v10.41l3.308-3.308a1 1 0 1 1 1.414 1.414l-3.6 3.6a2.99 2.99 0 0 1-2.002.877 1.012 1.012 0 0 1-.24 0 2.99 2.99 0 0 1-2.001-.876l-3.601-3.601a1 1 0 1 1 1.414-1.414L15 20.409V10a1 1 0 0 1 1-1Z" }),
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M16 3c7.18 0 13 5.82 13 13s-5.82 13-13 13S3 23.18 3 16 8.82 3 16 3Zm11 13c0-6.075-4.925-11-11-11S5 9.925 5 16s4.925 11 11 11 11-4.925 11-11Z" })));
});
